import { createSlice } from '@reduxjs/toolkit';
import {
  getProcurementStatusData,
  getProductTypeData,
  getProcurementTypeData,
  getEvaluationStatusData,
  getCategoryData,
} from './thunk';

export const initialState = {
  procurementStatusData: [],
  productTypeData: [],
  procurementTypeData: [],
  evaluationStatusData: [],
  categoryData: [],
  loading: false,
  error: {},
};

const DashboardProcurementSlice = createSlice({
  name: 'DashboardProcurement',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // Procurement Status Data
    builder.addCase(getProcurementStatusData.pending, state => {
      state.loading = true;
    });
    builder.addCase(getProcurementStatusData.fulfilled, (state, action) => {
      state.loading = false;
      state.procurementStatusData = action.payload;
    });
    builder.addCase(getProcurementStatusData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.error || null;
    });

    // Product Type Data
    builder.addCase(getProductTypeData.fulfilled, (state, action) => {
      state.productTypeData = action.payload;
    });
    builder.addCase(getProductTypeData.rejected, (state, action) => {
      state.error = action.payload?.error || null;
    });

    // Procurement Type Data
    builder.addCase(getProcurementTypeData.fulfilled, (state, action) => {
      state.procurementTypeData = action.payload;
    });
    builder.addCase(getProcurementTypeData.rejected, (state, action) => {
      state.error = action.payload?.error || null;
    });

    // Evaluation Status Data
    builder.addCase(getEvaluationStatusData.fulfilled, (state, action) => {
      state.evaluationStatusData = action.payload;
    });
    builder.addCase(getEvaluationStatusData.rejected, (state, action) => {
      state.error = action.payload?.error || null;
    });

    // Category Data
    builder.addCase(getCategoryData.fulfilled, (state, action) => {
      state.categoryData = action.payload;
    });
    builder.addCase(getCategoryData.rejected, (state, action) => {
      state.error = action.payload?.error || null;
    });
  },
});

export default DashboardProcurementSlice.reducer;
